import { CouponManagementState } from '../initial.state';
import { CouponManageActionTypes } from '../actions/couponsManagement.actions';

function CouponManagementReducer(state = new CouponManagementState(), action) {
  const { payload } = action;
  const { data, index } = payload || {};
  switch (action.type) {
    case CouponManageActionTypes.LOAD_COUPONS_SUCCESS:
      return {
        ...state,
        coupons: action.payload.data,
      };

    case CouponManageActionTypes.ADD_COUPON_SUCCESS:
      return {
        ...state,
        coupons: {
          ...state.coupons,
          content: [data, ...(state.coupons?.content || [])],
        },
      };

    case CouponManageActionTypes.UPDATE_COUPON_SUCCESS:
      return {
        ...state,
        coupons: {
          ...state.coupons,
          content: (state.coupons.content || [])
            .slice(0, index)
            .concat(data, (state.coupons.content || []).slice(index + 1)),
        },
      };

    case CouponManageActionTypes.LOAD_CATALOGUE_SUCCESS:
      return {
        ...state,
        catalogues: action.payload.data,
      };

    default:
      return state;
  }
}

export { CouponManagementReducer };
